import * as interpolation from './interpolation';
import * as cursor from './cursor';
import Masonry from "masonry-layout";

export default (node) => {
	const list = document.querySelector('.js-list');
	const apply = document.querySelector('.js-apply');
	const reset = document.querySelector('.js-reset');
	const form = document.querySelector('form');
	const ajax_url = form.getAttribute('data-action');
	const filters = form.querySelectorAll('.js-filter');
	const inputs = form.querySelectorAll('input');
	const cpt = form.dataset.cpt;
	const images = document.querySelector('.js-images');
	const loader = document.querySelector('.js-loader');
	const seed = node.getAttribute('data-seed');
	const lang = node.getAttribute('data-lang');

	if (!cpt) { return }

	window.locomotive.on('call', (func, args, obj) => {
		if (func == "paginate") {
			const paged = obj.el.getAttribute('data-paged');
			obj.el.remove();
			filter(paged);
		}
	});

	if (apply) {
		apply.addEventListener('click', () => {
			filter();
		});
	}

	if (reset) {
		reset.addEventListener('click', () => {
			inputs.forEach((input) => {
				input.checked = false;
			});

			filter();
		});
	}

	function filter(paged = 1) {
		const formData = new FormData(form);
		const xhr = new XMLHttpRequest();

		formData.append('action', 'filter_cpt');
		formData.append('cpt', cpt);
		formData.append('paged', paged);
		formData.append('lang', lang);

		if (seed) {
			formData.append('seed', seed);
		}

		xhr.open('POST', ajax_url, true);
		xhr.onreadystatechange = () => {
		    if (xhr.readyState === 4 && (xhr.status === 200 || xhr.status === 0)) {
		        const response = JSON.parse(xhr.response);

				if (paged == response.last_page || response.count == 0) {
					loader.classList.add('d-none');
				} else {
					loader.classList.remove('d-none');
				}
				
				if (paged == 1) {
					list.innerHTML = "";
					
					if (images) {
						images.innerHTML = "";
					}
				}

				var tmp = document.createElement('div');
				tmp.innerHTML = response.html;
				while (tmp.firstChild) {
				  list.appendChild(tmp.firstChild);
				}

				if (window.masonry) {
					window.masonry.destroy();
					var grid = document.querySelector('.js-masonry');
					var msnry = new Masonry(grid, {
					  itemSelector: '.js-masonry-item',
					  columnWidth: '.js-masonry-item',
					  percentPosition: true
					});

					conditioner.hydrate(grid);

					window.masonry = msnry;
				}


				if (images) {
					var tmp = document.createElement('div');
					tmp.innerHTML = response.images;
					while (tmp.firstChild) {
					  images.appendChild(tmp.firstChild);
					}

					interpolation.update();
				}

				window.locomotive.update();
				cursor.listeners();

				if (paged == 1) {
					window.locomotive.update();
					window.history.pushState({}, '', response.url);
					window.locomotive.scrollTo(node, {
						duration: 500
					});
				}
				
		    }
		};

		xhr.send(formData);
	}
};